import { get } from 'lodash';
import cmp from '../../lib/cmp';
import './sm-footer.less';



export default cmp(null, () => {
  const year = (new Date()).getFullYear();
  const privacyPolicyUrl = get(window, 'SPM_CONFIG.experiment.data.privacy_policy_url', 'https://splitmetrics.com/legal/privacy-policy/');

  return `
    <div class="sm-footer">
    © ${year} Stor.re
      <div class="links">
        <a href="${privacyPolicyUrl}" target="_blank" rel="noopener noreferrer">${__('sm@_privacy_policy_footer')}</a>
        <a href="https://splitmetrics.com/legal/terms-of-service/" target="_blank" rel="noopener noreferrer">${__('sm@_terms_of_service_footer')}</a>
      </div>
    </div>
  `;
});



// WEBPACK FOOTER //
// ./src/components/sm-footer/sm-footer.js